import React from "react";
import Synonyms from "./Synonyms";
import "./Meaning.css";

export default function Meaning(props){
  return(
    <div className="Meaning">
      <h4>{props.meaning.partOfSpeech}</h4>
      {props.meaning.definitions.map(function(definition,index){
        return(
          <div className="entry" key={index}>
            <div>
              <div className="definition">
                {definition.definition}
              </div>
              <div className="example">
                {definition.example}
              </div>
              <Synonyms synonyms={definition.synonyms} />
            </div>
          </div>
        );
      })}
      
    </div>
  )
}